import { mask } from 'remask';

export function maskPhoneNumber(value: string) {
  if (!value) return '';

  const cleanedValue = value.replace(/\D/g, ''); // Remove tudo que não é dígito

  if (cleanedValue.length <= 10) {
    return mask(value, ['(99) 9999-9999']);
  } else {
    return mask(value, ['(99) 9 9999-9999']);
  }
}
